import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonTable } from 'app/model/entity/commonTable';
import { TicketQuantityDisplaySetting } from 'app/model/entity/ticket-quantity-display-settings';
import { CommonTableService } from 'app/service/common-table.service';

@Component({
  selector: 'dialog-ticket-quantity-display-settings',
  templateUrl: './dialog-ticket-quantity-display-settings.component.html',
  styleUrls: ['./dialog-ticket-quantity-display-settings.component.scss']
})
export class DialogTicketQuantityDisplaySettingsComponent implements OnInit {
  public commonTable: CommonTable;
  public isSoldTickets: boolean;
  public ticketQuantityDisplaySetting: TicketQuantityDisplaySetting;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogTicketQuantityDisplaySettings,
    private dialogRef: MatDialogRef<DialogTicketQuantityDisplaySettingsComponent>,
    private commonTableService: CommonTableService
  ) {}

  ngOnInit(): void {
    this.ticketQuantityDisplaySetting = JSON.parse(this.data.commonTable.value);
    this.isSoldTickets = this.ticketQuantityDisplaySetting.isSoldTicket;
  }

  /**
   * onSubmit
   * @returns
   */
  public save(): void {
    let ticketQuantityDisplay = new TicketQuantityDisplaySetting(this.isSoldTickets);
    this.data.commonTable.value = JSON.stringify(ticketQuantityDisplay);
    this.commonTableService.save(this.data.commonTable).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  /**
   * closeDialog
   */
  public closeDialog(): void {
    this.dialogRef.close();
  }
}

export interface DialogTicketQuantityDisplaySettings {
  commonTable: CommonTable;
}
